import skinsDefaults from './skinsDefaults.json'

export type SkinDefaultsData = {
	types: Record<string, string>
	defaults: Record<string, string>
}

export const skinsInfo = skinsDefaults as Record<string, SkinDefaultsData>
